import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CCIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CC" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m12 3.5-.5.366.067-.616L11 3l.567-.25-.067-.616.5.366.5-.366-.067.616L13 3l-.567.25.067.616L12 3.5ZM11.481 6.84l-.5.365.067-.616-.567-.25.567-.25-.067-.616.5.366.5-.366-.066.616.566.25-.566.25.066.616-.5-.366ZM13 9.5l-.5.366.067-.616L12 9l.567-.25-.067-.616.5.366.5-.366-.067.616L14 9l-.567.25.067.616L13 9.5ZM13.5 4.75l-.25.183.034-.308L13 4.5l.284-.125-.034-.308.25.183.25-.183-.034.308L14 4.5l-.284.125.034.308-.25-.183ZM3.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        clipRule="evenodd"
      />
      <Path
        fill="#915E2B"
        d="m3.245 5.994-.18-.127c.397-.52.292-1.246.18-1.724l.73-.172c.167.711-.205 1.334-.73 2.023Z"
      />
      <Path
        fill="#FECA00"
        d="M8.396 4.5c.8 0 1.436.28 1.729 1.042-.232-.23-.589-.388-1.125-.368-.828 0-1.367.646-1.367 1.198 0 .552.539 1.303 1.367 1.303.416-.006.723-.085.947-.204-.329.565-.85.823-1.55.823a1.897 1.897 0 0 1 0-3.794Z"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M3.5 4.37c.828 0 1.357-.224 1.357-.5s-.529-.5-1.357-.5-1.258.224-1.258.5.43.5 1.258.5Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
